import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { track } from "./metaPixel";

export default function MetaRouteTracker() {
  const location = useLocation();
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    track("PageView");
  }, [location.pathname, location.search, location.hash]);

  return null;
}
